export default class mainNav {
  constructor() {
    this.breakPoint = '(max-width: 1279px)';
    this.navEl = document.querySelector('.main-nav');
    if (! this.navEl) return;
    this.initObserver();

    this.navMenuEl = this.navEl.querySelector('.main-nav__menu-wrapper');
    this.navToggleEl = this.navEl.querySelector('.main-nav__menu-toggle');
    if (! (this.navMenuEl || this.navToggleEl)) return;

    this.subMenus = this.navEl.querySelectorAll('.sub-menu');
    this.subMenusToggles = this.navEl.querySelectorAll('.sub-menu-toggle');
    
    this.subMenusToggles.forEach((toggle, index) => {
      toggle.setAttribute('aria-controls', `sub-menu-${index}`);
      this.subMenus[index].setAttribute('id', `sub-menu-${index}`);
    });

    this.responsiveAriaTags();

    this._bindEvents();
  }

  _bindEvents() {
    this.navToggleEl.addEventListener('click', event => {
      this.navEl.classList.toggle('has-menu-open');
      this.navToggleEl.setAttribute('aria-expanded', (this.navToggleEl.getAttribute('aria-expanded') === 'true') ? false : true);

      if (window.matchMedia(this.breakPoint).matches) {
        this.navMenuEl.setAttribute('aria-hidden', (this.navMenuEl.getAttribute('aria-hidden') === 'true') ? false : true);
      }
    });

    document.addEventListener('click', event => {
      if (this.navEl.contains(event.target)) return; // click inside menu

      this.navEl.classList.remove('has-menu-open');
      this.navToggleEl.setAttribute('aria-expanded', false);

      if (window.matchMedia(this.breakPoint).matches) {
        this.navMenuEl.setAttribute('aria-hidden', true);

        this.subMenusToggles.forEach((toggle, index) => {
          toggle.setAttribute('aria-expanded', false);
          this.subMenus[index].setAttribute('aria-hidden', true);
        });
      }
    });

    this.subMenusToggles.forEach((toggle, index) => {
      toggle.addEventListener('click', event => {
        toggle.setAttribute('aria-expanded', (toggle.getAttribute('aria-expanded') === 'true') ? false : true);
        this.subMenus[index].setAttribute('aria-hidden', (this.subMenus[index].getAttribute('aria-hidden') === 'true') ? false : true);
      });
    });

    window.addEventListener('resize', event => {
      this.responsiveAriaTags();
    });
  }
  responsiveAriaTags() {
    if (window.matchMedia(this.breakPoint).matches) {
      this.navToggleEl.disabled = false;
      this.navMenuEl.setAttribute('aria-hidden', true);

      this.subMenusToggles.forEach((toggle, index) => {
        toggle.disabled = false;
        this.subMenus[index].setAttribute('aria-hidden', true);
      });
    }
    else {
      this.navToggleEl.disabled = true;
      this.navEl.classList.remove('has-menu-open');
      this.navToggleEl.setAttribute('aria-expanded', false);
      this.navMenuEl.removeAttribute('aria-hidden');
      
      this.subMenusToggles.forEach((toggle, index) => {
        toggle.disabled = true;
        this.subMenus[index].removeAttribute('aria-hidden');
      });
    }
  }
  initObserver() {
    this.scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.navEl.classList.remove('is-moving');
        }
        else {
          this.navEl.classList.add('is-moving');
        }
      });
    }, {
      threshold: 1,
      // rootMargin: "100px 0px 0px 0px",
    });
  
    this.scrollObserver.observe(this.navEl.parentElement);
  }
}
